import React, { createContext, useState, useEffect } from "react"

const def = {
  roll: [0, 0, 0, 0, 0],
  rollingTimeMs: [0, 0, 0, 0, 0],
  activeItems: [null, null, null, null, null],
  showedLines: [],
}

export const GameContext = createContext(def)

export const GameProvider = ({ children }) => {
  const [state, setState] = useState(def)

  useEffect(() => {
    const action = e => {
      //console.log("message", e.data)
      let x = def
      try {
        x = JSON.parse(e && e.data)
        if (x && x.target === "state") {
          //console.log({ ...x.slotsState })
          setState({
            ...x.slotsState,
            //showedLines: [3, 5, 7, 11, 17],
            //activeLine: 3,
            //activeItems: x.slotsState.roll,
          })
        }
      } catch (e) {
        x = state
      }
    }
    window.addEventListener("message", action)
    return () => window.removeEventListener("message", action)
  }, [])

  return (
    <GameContext.Provider value={{ state }}>{children}</GameContext.Provider>
  )
}
